import { Companies, Months, Offers, Utils } from "../Const";

/**
 * ! Données FAKE
 *
 * Renvoie le nombre d'offres par entreprise (5 premières entreprises)
 *
 * @returns {NivoPieChartData} - Données pour le graphique en camembert de Nivo
 */
export function getCompaniesOffersData() {
  const chartData = [];
  const firstFiveCompanies = Companies.firstFiveCompanies;

  firstFiveCompanies.forEach((company) => {
    chartData.push({
      label: company,
      id: company,
      value: Utils.generateData(1, 100, 900)[0],
    });
  });

  return chartData;
}

/**
 * ! Données FAKE
 *
 * Renvoie le nombre d'offres par catégorie selon l'entreprise sélectionnée
 *
 * @returns {NivoPieChartData} - Données pour le graphique en camembert de Nivo
 */
export function getCompanyOffersByCategoryData() {
  const chartData = [];
  const categories = Offers.categories;

  categories.forEach((category) => {
    chartData.push({
      label: category,
      id: category,
      value: Utils.generateData(1, 100, 900)[0],
    });
  });

  return chartData;
}

/**
 * ! Données FAKE
 *
 * Renvoie le nombre d'offres par catégorie, par mois, selon l'entreprise sélectionnée
 *
 * @returns {NivoBarChartData} - Données pour le graphique en barres de Nivo
 */
export function getCompanyOffersByCategoryByMonthData() {
  const months = Months.all;
  const categories = Offers.categories;

  const chartData = [];

  months.forEach((month) => {
    const data = {
      Date: month,
    };
    categories.forEach((category) => {
      data[category] = Utils.generateData(1, 100, 900)[0];
    });
    chartData.push(data);
  });

  return chartData;
}
